import React from "react"
import { BrowserRouter as Router, Route, Routes, Link } from "react-router"
import { Home } from "./Home"
import { About } from "./About"
import { Header } from "./Header"
import { AutoplayVideo } from "../VideoLink/AutoPlayVideo"
import { MeasureAir } from "../FocusPages/FocusMeasureAir"
import { MeasureWater } from "../FocusPages/FocusMeasureWater"
import { MonitorAssets } from "../FocusPages/FocusMonitorAssets"
import { MonitorNetworkConnectivity } from "../FocusPages/FocusMonitorNetworkConnectivity"
import { MonitorCustomDevice } from "../FocusPages/FocusMonitorCustomDevice"
import { ControlFans } from "../FocusPages/FocusControlFans"
import { ControlDampers } from "../FocusPages/FocusControlDampers"
import { AnalyzeOnlineAi } from "../FocusPages/FocusAnalyzeOnlineAi"
import { AnalyzeData } from "../FocusPages/FocusAnalyzeData"
import { AnalyzeOrigin } from "../FocusPages/FocusAnalyzeOrigin"
import { AnalyzeMicrosoftGraph } from "../FocusPages/FocusAnalyzeMicrosoftGraph"
import { AnalyzeDisplays } from "../FocusPages/FocusAnalyzeDisplays"
import { ProductOverview } from "../ProductPages/ProductsOverview"
import { ProductCategory } from "../ProductPages/ProductCategory"
import { SpecificProduct } from "../ProductPages/SpecificProduct"
import { Cart } from "../Cart/Cart"
import { Contact } from "../Contact/Contact"
import { ConfiguratorScreen } from "../Configurators/ConfiguratorScreen"
import { HeaderTemporary } from "./HeaderTemporary"
import { FeatureFlags } from "@core-frontend/Core/FeatureFlags"

export function ECSenzSiteApp(): React.JSX.Element {
    return (
         <Router>
            <div>
                {FeatureFlags.showNewHeader() ? <Header /> : <HeaderTemporary />}
                
                <main style={styles.main}>
                    {/* <Routes> */}
                        {/* Catch-all route - shows Home for ANY path */}
                        <Home />
                        
                        {/* Main pages */}
                        {/* <Route path="/" element={<Home />} /> */}

                        {/* Measure routes */}
                        {/* <Route path="/ecstore/measure/air" element={<MeasureAir />} />
                        <Route path="/ecstore/measure/water" element={<MeasureWater />} />
                         */}
                        {/* Monitor routes */}
                        {/* <Route path="/ecstore/monitor/assets" element={<MonitorAssets/>} />
                        <Route path="/ecstore/monitor/networks" element={<MonitorNetworkConnectivity/>} />
                        <Route path="/ecstore/monitor/custom" element={<MonitorCustomDevice/>} /> */}

                        {/* Control routes */}
                        {/* <Route path="/ecstore/control/fans" element={<ControlFans/>} />
                        <Route path="/ecstore/control/dampers" element={<ControlDampers/>} /> */}

                        {/* Analyze routes */}
                        {/* <Route path="/ecstore/analyze/online" element={<AnalyzeOnlineAi/>} />
                        <Route path="/ecstore/analyze/excel" element={<AnalyzeData/>} />
                        <Route path="/ecstore/analyze/origin" element={<AnalyzeOrigin/>} />
                        <Route path="/ecstore/analyze/graph" element={<AnalyzeMicrosoftGraph/>} />
                        <Route path="/ecstore/analyze/displays" element={<AnalyzeDisplays/>} /> */}

                        {/* company routes */}
                        {/* <Route path="/ecstore/about" element={<About />} />
                        <Route path="/ecstore/allproducts" element={<ProductOverview />} />
                        <Route path="/ecstore/productcategory" element={<ProductCategory />} />
                        <Route path="/ecstore/product" element={<SpecificProduct />} />
                        <Route path="/ecstore/cart" element={<Cart/>} />
                        <Route path="/ecstore/contact" element={<Contact/>} /> */}

                        {/* Catch-all for testing */}
                        {/* <Route path="/ecstore/configurate" element={<ConfiguratorScreen />} /> */}
                    {/* </Routes> */}
                </main>
            </div>
        </Router>
    )
}

const styles = {
    nav: {
        marginTop: "56px",
        padding: "10px",
        background: "#F6F6F8",
        display: "flex",
        justifyContent: "center",
        gap: "20px",
    } as React.CSSProperties,
    main: {
        // marginTop: "80px",
        minHeight: "calc(100vh - 80px)",
        padding: "0",
    } as React.CSSProperties,
    background: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        backgroundColor: "red",
    } as React.CSSProperties,
}